export function photoAnim(options = {}) {
	const photoElements = document.querySelectorAll('.__jsPhotoAnim');

	if (!photoElements.length) return;

	const items = [];

	// Domyślne pasmo scrolla — identyczne jak w shade:
	// delta od -70 do +70 px względem środka ekranu.
	// delta = środek_ekranu - środek_elementu (dodatnia = element powyżej środka ekranu).
	const DEFAULT_START = -70;
	const DEFAULT_END = 70;

	// Docelowa pozycja obrazka to zawsze 0,0. Punkt startowy (skąd dojeżdża)
	// domyślnie -20,-20; można nadpisać przez data-photo-from. RANGE to tylko
	// górna granica bezpieczeństwa (clamp), nie wartość domyślna.
	const RANGE = 100;
	const DEFAULT_FROM_X = -20;
	const DEFAULT_FROM_Y = -20;

	// Domyślna animacja przezroczystości: od .2 (start pasma) do 1 (koniec pasma).
	const DEFAULT_OPACITY_FROM = 0.2;
	const DEFAULT_OPACITY_TO = 1;

	const clampRange = (v) => Math.max(-RANGE, Math.min(RANGE, v));

	// Ustala pasmo scrolla dla obrazka (ta sama logika co w shade, własne atrybuty):
	//   data-photo-range="start,end" -> jawne granice (np. "70,140")
	//   data-photo-range="w"         -> symetrycznie -w..w
	//   data-photo-offset="n"        -> przesuwa całe pasmo o n px (+ = wyżej/później)
	function getBand(element) {
		let start = DEFAULT_START;
		let end = DEFAULT_END;

		const rangeAttr = element.getAttribute('data-photo-range');
		if (rangeAttr) {
			const parts = rangeAttr
				.split(',')
				.map((s) => parseFloat(s.trim()))
				.filter((n) => !Number.isNaN(n));
			if (parts.length >= 2) {
				start = parts[0];
				end = parts[1];
			} else if (parts.length === 1) {
				start = -Math.abs(parts[0]);
				end = Math.abs(parts[0]);
			}
		}

		const offset = parseFloat(element.getAttribute('data-photo-offset'));
		if (!Number.isNaN(offset)) {
			start += offset;
			end += offset;
		}

		// zabezpieczenie przed dzieleniem przez zero
		if (end === start) end = start + 1;

		return { start, end };
	}

	// Punkt startowy przesunięcia (px), skąd obrazek dojeżdża do 0,0:
	//   data-photo-from="x,y" (np. "20,-20"); domyślnie -20,-20. Clamp do -20..20.
	function getFrom(element) {
		let x = DEFAULT_FROM_X;
		let y = DEFAULT_FROM_Y;

		const attr = element.getAttribute('data-photo-from');
		if (attr) {
			const parts = attr.split(',').map((s) => parseFloat(s.trim()));
			if (!Number.isNaN(parts[0])) x = parts[0];
			if (parts.length > 1 && !Number.isNaN(parts[1])) y = parts[1];
		}

		return { x: clampRange(x), y: clampRange(y) };
	}

	// Zakres przezroczystości: data-photo-opacity="from,to"; domyślnie .2,1.
	// Podanie jednej wartości ustawia tylko "from" (to = 1).
	function getOpacity(element) {
		let from = DEFAULT_OPACITY_FROM;
		let to = DEFAULT_OPACITY_TO;

		const attr = element.getAttribute('data-photo-opacity');
		if (attr) {
			const parts = attr.split(',').map((s) => parseFloat(s.trim()));
			if (!Number.isNaN(parts[0])) from = parts[0];
			if (parts.length > 1 && !Number.isNaN(parts[1])) to = parts[1];
		}

		return { from, to };
	}

	photoElements.forEach((element) => {
		items.push({
			element,
			band: getBand(element),
			from: getFrom(element),
			opacity: getOpacity(element),
			// Podpis pod obrazkiem (.gallery__photo_desc) animuje się dokładnie tak
			// samo jak obrazek nad nim — bierzemy najbliższy następny .gallery__photo_desc
			// będący rodzeństwem, o ile nie należy do kolejnego obrazka.
			desc: getDesc(element),
		});
	});

	// Zwraca .gallery__photo_desc leżący bezpośrednio pod danym obrazkiem
	// (kolejne rodzeństwo, jeszcze przed następnym <img>), albo null.
	function getDesc(element) {
		let sibling = element.nextElementSibling;
		while (sibling) {
			if (sibling.tagName === 'IMG') return null; // podpis należy do dalszego obrazka
			if (sibling.classList.contains('gallery__photo_desc')) return sibling;
			sibling = sibling.nextElementSibling;
		}
		return null;
	}

	// Postęp przewinięcia obrazka w jego paśmie.
	// 0 na dolnej granicy pasma (band.start), 1 na górnej (band.end).
	// Obcinamy z obu stron do 0..1 — pozycja ma tylko dojechać do 0,0 i tam zostać.
	const getScrollProgress = function (element, band) {
		const rect = element.getBoundingClientRect();
		const vh = window.innerHeight || document.documentElement.clientHeight;
		const screenCenter = vh / 2;

		// punkt odniesienia obrazka - jego środek w układzie viewportu
		const elementCenter = rect.top + (rect.height / 2);

		// odległość środka obrazka względem środka ekranu
		// (dodatnia = środek obrazka powyżej środka ekranu)
		const delta = screenCenter - elementCenter;

		// 0 na dolnej granicy pasma (band.start), 1 na górnej (band.end)
		const progress = (delta - band.start) / (band.end - band.start);
		return Math.max(0, Math.min(progress, 1));
	};

	const update = function (item) {
		const progress = getScrollProgress(item.element, item.band);

		// pozycja = start * (1 - progress):
		// progress 0 -> punkt startowy (from), progress 1 -> 0,0.
		// Wartość wprost z wartości scrolla w paśmie (bez CSS transition).
		const x = item.from.x * (1 - progress);
		const y = item.from.y * (1 - progress);

		// przezroczystość: from (progress 0) -> to (progress 1), liniowo ze scrollem
		const opacity = item.opacity.from + progress * (item.opacity.to - item.opacity.from);

		const transform = `translate3d(${x}px, ${y}px, 0)`;
		item.element.style.transform = transform;
		item.element.style.opacity = opacity;

		// podpis dziedziczy dokładnie tę samą animację co obrazek nad nim
		if (item.desc) {
			item.desc.style.transform = transform;
			item.desc.style.opacity = opacity;
		}
	};

	// Aktualizuj tylko obrazki widoczne w viewport
	const active = new Set();
	let ticking = false;

	const onScroll = function () {
		if (ticking) return;
		ticking = true;
		window.requestAnimationFrame(() => {
			active.forEach((item) => update(item));
			ticking = false;
		});
	};

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			const item = items.find((i) => i.element === entry.target);
			if (!item) return;

			if (entry.isIntersecting) {
				active.add(item);
			} else {
				active.delete(item);
			}
			update(item);
		});
	}, {
		root: null,
		threshold: 0,
	});

	items.forEach((item) => {
		observer.observe(item.element);
		update(item);
	});

	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', onScroll, { passive: true });
}
